import { RestClient } from '@affstore-ds/restclient'

import config from '../../config'

export const setErrorCallback = async () => {
  const { errorCallback } = await config.get()

  if (errorCallback) {
    RestClient.setResponseErrorCallback(errorCallback)
  }
}
